export const NOTE_ANSWER = "NOTE_ANSWER";
export const CHANGING_QUESTION = "CHANGING_QUESTION";
export const CHANGING_ANIMATION = "CHANGING_ANIMATION";
export const SET_USER_EMAIL = "SET_USER_EMAIL";
export const SET_USER_SUM = "SET_USER_SUM";
export const SET_PIXEL_OBJECT = "SET_PIXEL_OBJECT";
export const SET_REMOTE_CONFIG_VALUES = "SET_REMOTE_CONFIG_VALUES";
export const SET_AUDIO_VALUE = "SET_AUDIO_VALUE";
export const HANDLE_SET_THEME = "HANDLE_SET_THEME";
export const SET_ANALYTICS_INIT = "SET_ANALYTICS_INIT";
export const SET_LANDING_ID = "SET_LANDING_ID";

export function changingDisplay(display) {
  return (dispatch) => {
    dispatch({
      type: CHANGING_ANIMATION,
      payload: true,
    });
    setTimeout(() => {
      dispatch({
        type: CHANGING_DISPLAY,
        payload: display,
      });
    }, 500);
    setTimeout(() => {
      dispatch({
        type: CHANGING_ANIMATION,
        payload: false,
      });
    }, 2000);
  };
}

export function changingQuestion(num, length) {
  if (num <= length) {
    return (dispatch) => {
      dispatch({
        type: CHANGING_QUESTION,
        payload: num,
      });
    };
  } else {
    return false;
  }
}

export function noteAnswer(route, answerArray) {
  return (dispatch) => {
    dispatch({
      type: NOTE_ANSWER,
      route,
      answerArray,
    });
  };
}

export function setUserEmail(email) {
  return (dispatch) => {
    dispatch({
      type: SET_USER_EMAIL,
      payload: email,
    });
  };
}

export function setUserSum(sum) {
  return (dispatch) => {
    dispatch({
      type: SET_USER_SUM,
      payload: sum,
    });
  };
}

export function setPixelObject(object) {
  return (dispatch) => {
    dispatch({
      type: SET_PIXEL_OBJECT,
      payload: object,
    });
  };
}

export function setRemoteConfigValues(object) {
  return (dispatch) => {
    dispatch({
      type: SET_REMOTE_CONFIG_VALUES,
      payload: object,
    });
  };
}

export function setAudioValue(index, value) {
  return (dispatch, getState) => {
    const audioArray = getState().questions.audioValues;
    audioArray[index] = value;
    dispatch({
      type: SET_AUDIO_VALUE,
      payload: audioArray,
    });
  };
}

export function handleSetTheme(theme) {
  return (dispatch) => {
    dispatch({
      type: HANDLE_SET_THEME,
      payload: theme,
    });
  };
}

export function setAnalyticsInit(onboardingId) {
  return (dispatch) => {
    dispatch({
      type: SET_ANALYTICS_INIT,
      payload: onboardingId,
    });
  };
}

export function setLandingId(landingId) {
  return (dispatch) => {
    dispatch({
      type: SET_LANDING_ID,
      payload: landingId,
    });
  };
}
